// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"6d1f1b3d","590":"193ceb2c"}[chunkId] + ".chunk.js";
};